import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory, Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import ArrowBack from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import { createCottageRequest } from 'actions/cottage';
import * as cottageSelectors from 'selectors/cottage';
import Errors from 'components/shared/Errors';
import Success from 'components/shared/Success';
import { isStrict as isStrictSelector, success as successSelector } from 'selectors/user';
import PATHS from 'constants/paths';
import Main from 'components/templates/Main';
import CreateComponent from '../components/CottageCreate';

const getError = (error) => {
  if (error && error.status === 400 && error.message === 'User does not own room') {
    return {
      message: (
        <FormattedMessage
          id="error.notAllowedError"
          defaultMessage="You are not allowed to view this page,
            this can happen if you logged in with another e-mail
            address than the one linked to this cottage.
            If that is the case log out and login with the e-mail
            linked to this ad to display this page."
        />
      ),
    };
  }

  return error;
};

const CottageCreate = () => {
  const dispatch = useDispatch();
  const { dialog } = useParams();
  const history = useHistory();
  const cottage = useSelector(cottageSelectors.data);
  const error = useSelector(cottageSelectors.error);
  const isLoading = useSelector(cottageSelectors.isFetching);
  const isStrict = useSelector(isStrictSelector);
  const success = useSelector(successSelector);
  const updatingDialogs = useSelector(cottageSelectors.updatingDialogs);

  React.useEffect(() => {
    if (!isLoading && !isStrict) {
      history.replace(`${PATHS.users.profile}?next=${PATHS.cottages.create}`);
    }
  }, [isStrict]);

  React.useEffect(() => {
    if (!isLoading && cottage && cottage.id) {
      history.replace(PATHS.cottages.edit.replace(':cottageId', cottage.id));
    }
  }, [cottage]);

  const onSubmit = (values) => {
    dispatch(
      createCottageRequest({
        values: {
          ...values,
          commission: dialog !== 'fixed' ? true : undefined,
        },
      }),
    );
  };

  const onClose = () => {
    history.push(PATHS.cottages.root);
  };

  return (
    <Main
      title={
        <div>
          <IconButton color="inherit" component={Link} to={PATHS.cottages.root}>
            <ArrowBack />
          </IconButton>
          <FormattedMessage id="cottages.newAd" defaultMessage="Create new ad" />
        </div>
      }
    >
      <CreateComponent
        onSubmit={onSubmit}
        onClose={onClose}
        isLoading={isLoading || updatingDialogs.base}
      />
      <Success success={success} />
      <Errors errors={getError(error)} />
    </Main>
  );
};

export default CottageCreate;
